<script lang="tsx">
  import { defineComponent, PropType, computed } from 'vue'
  import NewBsBox from '@xhs/yam-beer/cmp/primitive/NewBsBox'
  import { BeerStyleObj } from '@xhs/yam-beer/core'
  import BaseSpinner from './BaseSpinner.vue'
  import { BeerCls } from '../../../core/ds/index.js'
  import { loadingKeyframes, loadingCircleKeyframes } from './animation.js'

  /**
   * 带文字描述的 Loading
   */
  export default defineComponent({
    name: 'LoadingSpinner',
    props: {
      /**
       * @ignore
       */
      bs: {
        type: Object as PropType<BeerStyleObj>,
        default: () => ({}),
      },
      /**
       * @ignore
       * 加载中的文案
       * */
      text: {
        type: String as PropType<string>,
        default: '',
      },
      /**
       * 加载中文案的bs样式
       * @ignore
       */
      textBs: {
        type: Object as PropType<BeerStyleObj>,
        default: () => ({}),
      },
    },
    setup(props, { slots, attrs }) {
      const outerCls = computed(() => BeerCls({
        animation: `${loadingKeyframes} 2s linear infinite`,
      }))

      const innerCls = computed(() => BeerCls({
        strokeDashoffset: 240,
        strokeDasharray: 120,
        animation: `${loadingCircleKeyframes} 1.6s cubic-bezier(0.4, 0.15, 0.6, 0.85) infinite`,
      }))
      return () => (
          <NewBsBox
            bs={{
              flexDirection: 'column',
              display: 'inline-flex',
              alignItems: 'center',
              fontSize: 14,
              lineHeight: 22,
              ...props.bs,
            }}
          >
            <BaseSpinner
              outerCls={outerCls.value}
              innerCls={innerCls.value}
              {...attrs}
            />
            { slots.text ? slots.text() : <NewBsBox bs={{ mt: 8, ...props.textBs }}>{ props.text }</NewBsBox>}
          </NewBsBox>
        )
    },
  })

</script>
